<template>
  <div :id="navId" class="container container">
    <div class="article-spotify" :class="classes">
      <div v-if="!!$slots.content" class="slot" :class="slotClasses">
        <slot name="content" />
      </div>
      <div class="song">
        <iframe
          style="border-radius: 12px"
          :src="`https://open.spotify.com/embed/${trackUri}/${songUri}?utm_source=generator`"
          width="100%"
          height="352"
          frameBorder="0"
          allowfullscreen=""
          allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
          loading="lazy"
        ></iframe>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ArticleSpotify",
  props: {
    navId: {
      type: String,
      default: null,
    },
    intro: {
      type: Boolean,
      default: false,
    },
    flip: {
      type: Boolean,
      default: false,
    },
    withText: {
      type: Boolean,
      default: false,
    },
    centered: {
      type: Boolean,
      default: false,
    },
    songUri: {
      type: String,
      required: true,
    },
    trackUri: {
      type: String,
      default: "track",
    },
  },
  computed: {
    slotClasses() {
      return {
        "article-spotify--intro": this.intro,
      };
    },
    classes() {
      return {
        "article-spotify--flip": this.flip,
        "article-spotify--withText": this.withText,
        "article-spotify--centered": this.centered,
        "article-spotify--noSlot": !this.$slots.content,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.article-spotify {
  display: flex;
  flex-direction: column;
  margin-bottom: 40px;

  @include respond-above(md) {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-column-gap: 50px;
    margin-bottom: 60px;

    &--noSlot {
      display: block;
    }
  }

  &--flip {
    direction: rtl;
  }

  &--withText {
    margin-bottom: 20px;
  }

  &--centered {
    margin: 0 auto 60px;
    max-width: 627px;
    @include respond-above(md) {
      display: flex;
      margin-bottom: 80px;
    }
    .slot {
      :deep(p) {
        text-align: center;
      }
      :deep(h4) {
        text-align: center;
        @include respond-above(md) {
          @include t__editorial-headline-30;
          margin: 0 0 50px;
        }
      }
    }
  }

  &--intro {
    display: flex;
    align-items: center;

    :deep(p) {
      @include t__editorial-body-20;
      text-align: center;

      @include respond-above(md) {
        @include t__editorial-sub-headline-30;
        text-align: left;
      }
    }
  }
}

.slot {
  direction: initial;
  @include t__editorial-body-10;
  margin-bottom: 30px;

  @include respond-above(md) {
    display: flex;
    flex-direction: column;
    justify-content: center;
    @include t__editorial-body-20;
    margin-bottom: 0;
  }

  :deep(h4) {
    @include t__editorial-headline-10;
    margin-bottom: 10px;

    @include respond-above(md) {
      @include t__editorial-headline-20;
      margin-bottom: 20px;
    }
  }
}

.song {
  display: flex;
  align-items: center;
}
</style>
